import {
  Box,
  Button,
  Center,
  Heading,
  Icon,
  List,
  ListItem,
  Stack,
  Text,
  VStack,
} from '@chakra-ui/react';
import { Link as ReactLink } from 'react-router-dom';
import { Notification } from '../../components';
import { useIsMobileOrTouchDevice } from '../../hooks';
import { DonorInfo } from './components/steps/DonorInfo';
import { DonationAmount } from './components/steps/DonationAmount';
import { CaptureCheck } from './components/steps/CaptureCheck';
import { Review } from './components/steps/Review';
import { useMobileCheckDepositContext } from './context';
import { CheckFront } from '../../assets';
import { getDataTracking } from '../../utils';
import './MobileCheckDeposit.module.scss';

export const MobileCheckDeposit = () => {
  const {
    commands: { sendDonations },
  } = useMobileCheckDepositContext();
  const isMobileOrTouchDevice = useIsMobileOrTouchDevice();

  return (
    <Stack spacing={6}>
      <VStack>
        <Icon as={CheckFront} color="brand.primary.swatch1" w={16} h={9} />
        <Heading fontSize="1.5rem" color="brand.primary.swatch1">
          Mobile Check Deposit
        </Heading>
      </VStack>
      {isMobileOrTouchDevice ? (
        <Box>
          <Notification status="error" message={sendDonations.error?.message} />
          <List spacing={2}>
            <ListItem>
              <DonorInfo />
            </ListItem>
            <ListItem>
              <DonationAmount />
            </ListItem>
            <ListItem>
              <CaptureCheck checkType="front" />
            </ListItem>
            <ListItem>
              <CaptureCheck checkType="back" />
            </ListItem>
            <ListItem>
              <Review />
            </ListItem>
          </List>
        </Box>
      ) : (
        <Center>
          <Box w="356px">
            <Text fontSize="md">
              A smartphone is required to submit a check donation online. Please
              return to this page on your mobile device to deposit a check
              donation{' '}
            </Text>
            <Button
              w="full"
              as={ReactLink}
              variant="ghost"
              colorScheme="blue"
              tabIndex={-1}
              textDecoration="none"
              to="/"
              {...getDataTracking('returnToDashboard')}
            >
              Return to dashboard
            </Button>
            {/* TODO: Replace QR code when it is ready */}
            {/*  <Box boxShadow="0 0 6px rgba(0,0,0,0.20)" mt={6}> */}
            {/*    <Image src={TestMCDCode} /> */}
            {/*  </Box> */}
            {/*  <Center> */}
            {/*    <Box w="220px" className={styles.box} mt={6}> */}
            {/*      <Text align="center" color="brand.primary.swatch1"> */}
            {/*        Scan with your phone's camera to deposit a check */}
            {/*      </Text> */}
            {/*    </Box> */}
            {/*  </Center> */}
            {/* </Box> */}
          </Box>
        </Center>
      )}
    </Stack>
  );
};
